import { Location } from '@angular/common';
export const updateLocationId = (id: number | string, location: Location) => {
  location.go(location.path().split('/')[1] + '/' + id);
}
